import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TeacherHeader from "../common/TeacherHeader";
import Footer from "../common/Footer";
import { baseUrl } from "../../Utility/constants";
import { ReportCardEndpoints } from "../../Utility/Endpoints";
import { getSchoolId, getCurrentSession } from "../../Utility/commonFunctions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useRef } from "react";

const OverallAnnualExamReport = () => {
    const reportRef = useRef(null);
    const [report, setReport] = useState(null);
    const [school, setSchool] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sessionDetails, setSessionDetails] = useState("");
    const [teacherData, setTeacherDData] = useState([]);

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = async () => {
        try {
            setLoading(true);

            const teacherId = localStorage.getItem("userID");

            // Teacher Details
            const url = `${baseUrl}/api/Teachers/GetTeacherDetailsByTeacherId?teacherId=${teacherId}`;
            const teacherResponse = await axios.get(url);
            if (
                teacherResponse &&
                teacherResponse.data &&
                teacherResponse.data.length > 0
            ) {
                setTeacherDData(teacherResponse?.data?.[0]);
            }
            else {
                setTeacherDData([]);
            }

            // Overall Annual Report API
            const reportResponse = await axios.get(
                `${ReportCardEndpoints.OverallAnnualExamReportByTeacherId}?teacherId=${teacherId}`
            );

            // School Information
            const schoolId = await getSchoolId();

            const schoolResponse = await axios.get(
                `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
            );

            // Fetch current session name
            const sessionName = await getCurrentSession();

            setSessionDetails(sessionName);
            setReport(reportResponse.data);
            setSchool(schoolResponse.data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to load Overall Annual Exam Report.");
        } finally {
            setLoading(false);
        }
    };

    const exportToPDF = async () => {
        const input = reportRef.current;

        if (!input) return;

        try {
            const canvas = await html2canvas(input, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#ffffff",
                scrollY: -window.scrollY,
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }

            pdf.save(
                `Overall_Annual_Exam_Report_Class_${teacherData?.classSubjectDetails?.[0]?.class}_${sessionDetails}.pdf`
            );

            toast.success("PDF downloaded successfully.");
        } catch (err) {
            console.error(err);
            toast.error("Failed to export PDF.");
        }
    };

    return (
        <>
            <TeacherHeader />

            <div className="container my-4">
                <div className="d-flex justify-content-end mb-3">
                    <button
                        className="btn btn-danger"
                        onClick={exportToPDF}
                    >
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                        Export PDF
                    </button>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary"></div>
                    </div>
                ) : (
                    <div
                        ref={reportRef}
                        className="bg-white border border-dark p-4"
                        style={{
                            maxWidth: "900px",
                            margin: "0 auto",
                            fontFamily: "Times New Roman, serif",
                            color: "#000"
                        }}
                    >

                        {/* =======================================================
                                SCHOOL HEADER (Same as Leaving Certificate)
                        ======================================================== */}

                        <table className="table table-bordered border-dark mb-0">
                            <tbody>
                                <tr>

                                    {/* School Logo */}

                                    <td
                                        style={{
                                            width: "140px",
                                            textAlign: "center",
                                            verticalAlign: "middle"
                                        }}
                                    >
                                        <img
                                            src={school?.logo}
                                            alt="School Logo"
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                                objectFit: "contain"
                                            }}
                                        />
                                    </td>

                                    {/* School Details */}

                                    <td
                                        className="text-center border-start-0 border-end-0"
                                        style={{ verticalAlign: "middle" }}
                                    >
                                        <h6 className="mb-1 fw-bold">
                                            {school?.organizationName}
                                        </h6>

                                        <h3 className="fw-bold mb-1 text-uppercase">
                                            {school?.schoolOrCollegeName}
                                        </h3>

                                        <div className="fw-semibold mb-1">
                                            (Affiliated to H.S.C. Board, Govt. of Maharashtra)
                                        </div>

                                        <div className="small">
                                            Address : {school?.address}
                                        </div>

                                        <div className="small">
                                            Phone :{" "}
                                            <strong>{school?.schoolOrCollegeContactNo}</strong>
                                            {" | "}
                                            Website :{" "}
                                            <strong>{school?.schoolWebsiteName}</strong>
                                        </div>

                                        <div className="small">
                                            Email : <strong>{school?.email}</strong>
                                        </div>

                                        <div className="small">
                                            U-DISE No : <strong>{school?.udiseNo}</strong>

                                            {(school?.ssC10thIndexNo ||
                                                school?.hsC12thIndexNo) && (
                                                    <>
                                                        {" | "}Index No :{" "}
                                                        <strong>
                                                            {school?.ssC10thIndexNo}
                                                            {school?.ssC10thIndexNo &&
                                                                school?.hsC12thIndexNo &&
                                                                " | "}
                                                            {school?.hsC12thIndexNo}
                                                        </strong>
                                                    </>
                                                )}
                                        </div>
                                    </td>

                                    {/* Empty Cell 

                                    <td style={{ width: "140px" }}></td>*/}

                                </tr>
                            </tbody>
                        </table>

                        {/* Recognition Number */}

                        {/* <table className="table table-bordered border-dark border-top-0 mb-3">
                            <tbody>
                                <tr>
                                    <td className="small">
                                        School / College Recognition No. :
                                        <strong>
                                            {" "}
                                            {school?.schoolRegistrationNumber}

                                            {school?.schoolRegistrationNumber &&
                                                school?.collegeRegistrationNumber &&
                                                " | "}

                                            {school?.collegeRegistrationNumber}
                                        </strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}

                        {/* =======================================================
                                    REPORT TITLE
                        ======================================================== */}

                        <div className="text-center mb-3">

                            <h5 className="fw-bold">
                                Annual Exam ({sessionDetails})
                            </h5>
                        </div>

                        {/* =======================================================
                                CLASS DETAILS
                        ======================================================== */}

                        <div className="row fw-bold mb-3">
                            <div className="col-8">
                                Class :- {teacherData?.classSubjectDetails[0].class}
                                {"   "}
                                Division :- {teacherData?.classSubjectDetails[0].class}
                            </div>

                            <div className="col-4 text-end">
                                Class Teacher :- {teacherData?.fullName}
                            </div>
                        </div>

                        {/* =======================================================
        RESULT SUMMARY TABLE (Matches PDF Page 11)
======================================================= */}

                        {/* =======================================================
        RESULT SUMMARY TABLE (PDF Style)
======================================================= */}

                        <table
                            className="table text-center align-middle mb-4"
                            style={{
                                border: "2px solid black",
                                borderCollapse: "collapse",
                                fontSize: "14px"
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{ border: "2px solid black", width: "105px" }}>
                                        Particulars
                                    </th>

                                    <th style={{ border: "2px solid black", width: "85px" }}>
                                        Distinction
                                        <br />
                                        Above 75%
                                    </th>

                                    <th style={{ border: "2px solid black", width: "104px" }}>
                                        First Class
                                        <br />
                                        60% to 74.99%
                                    </th>

                                    <th style={{ border: "2px solid black", width: "106px" }}>
                                        Second Class
                                        <br />
                                        45% to 59.99%
                                    </th>

                                    <th style={{ border: "2px solid black", width: "106px" }}>
                                        Pass Class
                                        <br />
                                        35% to 44.99%
                                    </th>

                                    <th style={{ border: "2px solid black", width: "52px" }}>
                                        Total
                                        <br />
                                        Passed
                                    </th>

                                    <th style={{ border: "2px solid black", width: "54px" }}>
                                        Absent
                                    </th>

                                    <th style={{ border: "2px solid black", width: "50px" }}>
                                        Failed
                                    </th>

                                    <th style={{ border: "2px solid black", width: "64px" }}>
                                        Total
                                        <br />
                                        Students
                                    </th>

                                    <th style={{ border: "2px solid black", width: "102px" }}>
                                        Percentage of
                                        <br />
                                        Class Result %
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td style={{ border: "2px solid black" }} className="fw-bold">
                                        Total Students
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.distinction}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.firstClass}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.secondClass}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.passClass}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.totalPassed}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.absent}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.totalFailed}
                                    </td>

                                    <td style={{ border: "2px solid black" }}>
                                        {report?.totalStudents}
                                    </td>

                                    <td style={{ border: "2px solid black" }} className="fw-bold">
                                        {Number(report?.classResultPercentage).toFixed(2)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {/* =======================================================
                                FAILED DETAILS TABLE
                        ======================================================== */}

                        <table
                            className="table text-center align-middle mb-4"
                            style={{
                                border: "2px solid black",
                                borderCollapse: "collapse",
                                fontSize: "14px"
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{ border: "2px solid black", width: "106px" }}>
                                        Failed Details
                                    </th>
                                    <th style={{ border: "2px solid black", width: "88px" }}>F1</th>
                                    <th style={{ border: "2px solid black", width: "106px" }}>F2</th>
                                    <th style={{ border: "2px solid black", width: "108px" }}>F3</th>
                                    <th style={{ border: "2px solid black", width: "108px" }}>F4</th>
                                    <th style={{ border: "2px solid black", width: "55px" }}>F5</th>
                                    <th style={{ border: "2px solid black", width: "55px" }}>F6</th>
                                    <th style={{ border: "2px solid black", width: "52px" }}>F7</th>
                                    <th style={{ border: "2px solid black", width: "64px" }}>Absent</th>
                                    <th style={{ border: "2px solid black" }}>Total Failed</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td style={{ border: "2px solid black" }}>Total Students</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f1}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f2}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f3}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f4}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f5}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f6}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.failedDetails?.f7}</td>
                                    <td style={{ border: "2px solid black" }}>{report?.absent}</td>
                                    <td style={{ border: "2px solid black" }} className="fw-bold">
                                        {report?.totalFailed}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="small fw-semibold mt-1">
                            * Filled By Class Teacher
                        </div>

                        {/* =======================================================
                                SIGNATURES
                        ======================================================== */}

                        <div className="row text-center">

                            <div className="col-3">
                                <div style={{ height: "50px" }}></div>
                                <div className="fw-semibold">Checked By</div>
                            </div>

                            <div className="col-3">
                                <div style={{ height: "50px" }}></div>
                                <div>Class Teacher</div>
                            </div>

                            <div className="col-3">
                                <div style={{ height: "50px" }}></div>
                                <div className="fw-semibold">Vice-Principal</div>
                            </div>

                            <div className="col-3">
                                <div style={{ height: "50px" }}></div>
                                <div className="fw-semibold">Principal</div>
                            </div>

                        </div>

                    </div>
                )}

            </div>

            <ToastContainer position="top-right" autoClose={3000} />
            <Footer />
        </>
    );
};

export default OverallAnnualExamReport;